  export enum LifeStructure { 
      Salary = 'salary',
      Dollar = 'dollar'
   }